import React from 'react';
import { CheckCircle } from '@phosphor-icons/react';
import classNames from 'classnames';
import parse from 'html-react-parser';

import { ChangingTip } from '../custom';
import { Button, Spinner, Modal } from '../general';

interface Props {
  show: boolean;
  onHide?: () => void;
  isProcessing?: boolean;
  heading: string;
  subheading?: string | React.ReactNode;
  btns?: { label: string; onClick: () => void }[];
  tipsList?: string[];
}

const ConfirmModal: React.FC<Props> = (props) => {
  const { show, onHide, isProcessing, heading, subheading, btns, tipsList } =
    props;

  return (
    <Modal show={show} onHide={!isProcessing ? onHide : undefined}>
      <Modal.Body centered>
        {isProcessing ? (
          <Spinner size="3xl" color="primary" />
        ) : (
          <CheckCircle color="var(--success-color)" size={100} />
        )}

        {heading && <h4>{parse(heading)}</h4>}

        {subheading &&
          (typeof subheading === 'string' ? (
            <div>{parse(subheading)}</div>
          ) : (
            subheading
          ))}

        {isProcessing && tipsList && <ChangingTip tipsList={tipsList} />}

        {btns && (
          <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-4">
            {btns.map((btn, index) => (
              <Button
                key={index}
                onClick={btn.onClick}
                colour={index === 1 ? 'pink' : 'primary'}
                className={classNames('w-full', {
                  'sm:w-1/2': btns.length > 1,
                })}
              >
                {btn.label}
              </Button>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmModal;
